/**
 * The account dropdown (§ Accountmenu). WP-08 owns this file.
 */
export const accountMenu = {
  trigger: 'Account',
  viewProfile: 'View profile',
  roles: {
    admin: 'Platform administrator',
    companyAdmin: 'Company admin',
    departmentAdmin: 'Department admin/coach',
  },
  company: {
    label: 'Company',
    switchTo: 'Switch to {{name}}',
  },
  accounts: {
    label: 'Other accounts',
    switchTo: 'Switch to {{name}}',
    addAnother: 'Sign in with another account',
  },
  manage: 'Manage',
  settings: 'Company profile',
  language: 'Language',
  theme: {
    label: 'Theme',
    light: 'Light',
    dark: 'Dark',
    system: 'System',
  },
  signOut: 'Sign out',
  signOutAll: 'Sign out of all accounts',
} as const;
